// Campus photo for /colleges/vassar-college: CC0 1.0, by BappleBusiness, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AVassar_Main_Campus_Drive.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/vassar-college/; credited under the photo.
const photo = {
    "slug": "vassar-college",
    "alt": "The drive leading to Main Building at Vassar College in Poughkeepsie, New York",
    "src": "/colleges/vassar-college/campus-1600.webp",
    "srcSmall": "/colleges/vassar-college/campus-800.webp",
    "srcMid": "/colleges/vassar-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/vassar-college/og.jpg",
    "title": "Vassar Main Campus Drive",
    "author": "BappleBusiness",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AVassar_Main_Campus_Drive.jpg",
    "read": "2026-10-01"
};

export default photo;
